export default {
  state: {
    filters: {
      search: '',
      type: 'airport',
      status: 'active',
      brands: ''
    },
    showCreateGeofence: false,
    refreshList: false,
    cloneId: 0
  },
  mutations: {
    setFilterSearch (state, value) { state.filters.search = value },
    setFilterStatus (state, value) { state.filters.status = value },
    setFilterBrands (state, value) { state.filters.brands = value },
    setFilterType (state, value) { state.filters.type = value },
    setShowCreateGeofence (state, value) { state.showCreateGeofence = value },
    setCloneGeofence (state, value) { state.cloneId = value },
    setRefreshList (state, value) { state.refreshList = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/geofences/geofence-filters.js